import { FC, ReactNode } from 'react'
import { Col } from 'antd'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../../components/formik-component'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerText from '../../../../components/custom_components/Text'
import { FontSize } from '../../../../components/util/types'

interface ContractChangeRowProps {
  name: string
  label: string
  current: ReactNode
  subCurrent?: ReactNode[]
  subCurrentFontSize?: FontSize
  change?: ReactNode
  subChange?: ReactNode[]
  subChangeFontSize?: FontSize
  warnings?: string[]
  mt?: 's' | 'xl' | undefined
  note?: string
}
export const ContractChangeRow: FC<ContractChangeRowProps> = ({
  name,
  label,
  current,
  subCurrent,
  subCurrentFontSize = 's',
  change,
  subChange,
  subChangeFontSize = 's',
  warnings,
  mt = 's',
  note,
}) => {
  const [t] = useTranslation()

  const renderSubData = (data: ReactNode[], fontSize?: FontSize): ReactNode[] => {
    const res: ReactNode[] = []
    for (let i = 0; i < data.length; i++) {
      res.push(
        <PerText key={i} mt="xxxs" fontSize={fontSize} fontWeight="thin" color="secondary">
          {data[i]}
        </PerText>,
      )
    }
    return res
  }

  return (
    <PerSpacer mt={mt}>
      <PerFlexRow mb="xxxs">
        <Col span={12}>
          <PerText appearance="label-small" color="secondary">
            {t(`appraisalMeeting.contract.${label}`)}
          </PerText>
        </Col>
        {!!change && (
          <Col span={12}>
            <PerText appearance="label-small" color="secondary">
              {t(`appraisalMeeting.contract.${label}`)}
            </PerText>
          </Col>
        )}
      </PerFlexRow>
      <PerFlexRow>
        <Col span={12}>
          <PerText>{current}</PerText>
          {!!subCurrent && !!subCurrent.length && renderSubData(subCurrent, subCurrentFontSize)}
        </Col>
        {!!change && (
          <Col span={12}>
            <FormItem name={name + `.${label}`}>{change}</FormItem>
            {!!subChange && !!subChange.length && renderSubData(subChange, subChangeFontSize)}
          </Col>
        )}
      </PerFlexRow>
      <PerFlexRow>
        <Col span={12}></Col>
        <Col span={12}>
          {note && (
            <PerText mt="xxs" color="error" fontSize="xs">
              {note}
            </PerText>
          )}
          {warnings &&
            warnings.map((warning, i) => (
              <PerText mt="xxs" color="secondary" fontSize="xs" key={`${name}warning${i}`}>
                {warning}
              </PerText>
            ))}
        </Col>
      </PerFlexRow>
    </PerSpacer>
  )
}
